import request from '@/utils/request'

let getUploadList=()=>request.get('')
// 代理上传imei
let agentUpload=(data)=>request.post('/api/agent/addCanLockImeis',data,{'content-type':'multipart/form-data'})
let agentUploadSingle=(data)=>request.post('/api/agent/addCanLockImei',data,{'content-type':'application/json'})

// 增加测试imei
let adminUpload=(data)=>request.post('/api/test/addTestImei',data,{'content-type':'multipart/form-data'})
// 运营商批量加锁
let operatorUpload=(data)=>request.post('/api/lock/lock',data,{'content-type':'multipart/form-data'})
// 运营商单个加锁
let operatorUploadSingel=(data)=>request.post('/api/lock/singleLock',data,{'content-type':'application/x-www-form-urlencoded'})
// 运营商删除imei
let operatorDeleteUpload=(data)=>request.post('/api/lock/delete',data,{'content-type':'multipart/form-data'})
// 运营商删除单个imei
let operatorDeleteUploadSingel=(data)=>request.post('/api/lock/singleDelete',data,{'content-type':'application/x-www-form-urlencoded'})

// 删除测试imei
let adminDeleteUpload=(data)=>request.post('/api/test/deleteTestImei',data,{'content-type':'multipart/form-data'})

// 获取运营商imei上传记录
let getLockUploadIMEI=(data)=>request.post('/api/lock/getUploadLogs',data)

// 获取代理imei上传记录
let getAgentUploadIMEI=(data)=>request.post('/api/agent/getUploadLogs',data)
export default {
  getUploadList,
  agentUpload,
  adminUpload,
  operatorUpload,
  operatorDeleteUpload,
  adminDeleteUpload,
  getLockUploadIMEI,
  getAgentUploadIMEI,
  agentUploadSingle,
  operatorDeleteUploadSingel,
  operatorUploadSingel
}